// extracted by mini-css-extract-plugin
export var bottom = "thoughts-module--bottom--Vd5VS";
export var date = "thoughts-module--date--AMeEI";
export var english = "thoughts-module--english--h2K3s";
export var heading = "thoughts-module--heading--TJimY";
export var informations = "thoughts-module--informations--CVe9o";
export var noTags = "thoughts-module--noTags--pK8aC";
export var polish = "thoughts-module--polish--ksQT6";
export var post = "thoughts-module--post--6Eoz4";
export var postsWrapper = "thoughts-module--postsWrapper--pKM99";
export var tags = "thoughts-module--tags--+7wgO";
export var title = "thoughts-module--title--eFvlV";